import { useContext } from "react";

import { TenantContext } from "@nens/ranalib";

import { ProjectContext } from "@/stores/project-provider";

import { ProjectOverview } from "./project-overview";
import { ProjectWelcome } from "./project-welcome";

export function ProjectOverviewOrWelcome() {
  const project = useContext(ProjectContext);
  const authInfo = useContext(TenantContext);
  const userId = !authInfo.isPublic ? authInfo.user.id : undefined;

  const doneOnboarding = !(userId === project.creator.id && project.showOnboarding);

  if (doneOnboarding) return <ProjectOverview />;

  return <ProjectOverviewAndWelcome />;
}

function ProjectOverviewAndWelcome() {
  return (
    <>
      <ProjectWelcome />
      <ProjectOverview />
    </>
  );
}
